import { Checkbox, Input, Tab, TabList, makeStyles, tokens } from '@fluentui/react-components';
import { SearchRegular } from '@fluentui/react-icons';

export const EXECUTION_FILTER = {
  ALL: 'all',
  MINE: 'mine',
  ATTENTION: 'attention',
  DOCUMENTS: 'documents',
  REGULATORY: 'regulatory',
  TRAINING: 'training',
} as const;
export type TExecutionFilter = (typeof EXECUTION_FILTER)[keyof typeof EXECUTION_FILTER];

const FILTER_LABELS: Record<TExecutionFilter, string> = {
  [EXECUTION_FILTER.ALL]: 'All',
  [EXECUTION_FILTER.MINE]: 'My tasks',
  [EXECUTION_FILTER.ATTENTION]: 'Needs attention',
  [EXECUTION_FILTER.DOCUMENTS]: 'Documents',
  [EXECUTION_FILTER.REGULATORY]: 'Regulatory',
  [EXECUTION_FILTER.TRAINING]: 'Training',
};

const useStyles = makeStyles({
  root: { display: 'flex', flexDirection: 'column', gap: tokens.spacingVerticalS },
  controls: { display: 'flex', alignItems: 'center', gap: tokens.spacingHorizontalM, flexWrap: 'wrap' },
  search: { flex: 1, minWidth: '200px' },
  spacer: { marginLeft: 'auto' },
});

type TProps = {
  filter: TExecutionFilter;
  onFilterChange: (filter: TExecutionFilter) => void;
  search: string;
  onSearchChange: (value: string) => void;
  showCompleted: boolean;
  onShowCompletedChange: (value: boolean) => void;
};

// Simple focused filters (prompt Part 8) - not a large enterprise filter bar.
export const ExecutionFilters = ({
  filter,
  onFilterChange,
  search,
  onSearchChange,
  showCompleted,
  onShowCompletedChange,
}: TProps) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <TabList selectedValue={filter} onTabSelect={(_, data) => onFilterChange(data.value as TExecutionFilter)}>
        {Object.values(EXECUTION_FILTER).map((value) => (
          <Tab key={value} value={value}>
            {FILTER_LABELS[value]}
          </Tab>
        ))}
      </TabList>
      <div className={classes.controls}>
        <Input
          className={classes.search}
          value={search}
          onChange={(_, data) => onSearchChange(data.value)}
          contentBefore={<SearchRegular />}
          placeholder="Search tasks"
        />
        <Checkbox
          className={classes.spacer}
          checked={showCompleted}
          label="Show completed"
          onChange={(_, data) => onShowCompletedChange(Boolean(data.checked))}
        />
      </div>
    </div>
  );
};
